/* global BigInt */
// Форматирование денежных значений.
// Принимает и число, и строку (поля цены приходят с бэкенда/форм строкой),
// группирует разряды обычным пробелом — в отличие от toLocaleString(),
// который в ru-локали ставит неразрывный пробел и не даёт перенести
// длинное значение внутри блока.
// Целая часть группируется через строки, поэтому большие значения
// не теряют точность на Number.

const GROUP_SEPARATOR = " ";
const DECIMAL_SEPARATOR = ",";

function groupDigits(digits) {
  let result = "";
  for (let i = digits.length; i > 0; i -= 3) {
    const chunk = digits.slice(Math.max(0, i - 3), i);
    result = result ? chunk + GROUP_SEPARATOR + result : chunk;
  }
  return result;
}

export function formatMoney(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  let raw = typeof value === "number" ? String(value) : String(value).trim();

  // Экспоненциальная запись (Number с >=1e21) — разворачиваем через BigInt.
  if (/e[+-]?\d+$/i.test(raw)) {
    try {
      raw = BigInt(Number(raw)).toString();
    } catch {
      return String(value);
    }
  }

  const match = raw.match(/^([+-]?)(\d*)(?:[.,](\d+))?$/);
  if (!match) {
    // Не похоже на число — отдаём как есть, ничего не ломаем.
    return String(value);
  }

  const [, sign, intPart = "", fractionPart] = match;
  const integer = groupDigits(intPart.replace(/^0+(?=\d)/, "") || "0");
  const fraction = fractionPart ? fractionPart.replace(/0+$/, "") : "";

  return (
    sign + integer + (fraction ? DECIMAL_SEPARATOR + fraction : "")
  );
}

export default formatMoney;
